<template>
    <div class="editor ml-1 mr-1">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }" v-if="editable" class="mb-4">
            <div class="menubar">

                <el-button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold"
                >Vet</el-button>

                <el-button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic"
                >
                    Cursief</el-button>

                <el-button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.paragraph() }"
                        @click="commands.paragraph"
                >
                    Paragraaf</el-button>

                <el-button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list"
                >
                    Opsomming</el-button>

                <el-button
                        class="menubar__button"
                        :class="{ 'is-active': isActive.ordered_list() }"
                        @click="commands.ordered_list"
                >
                    Lijst</el-button>

                <el-tooltip class="item" effect="dark" content="Maak van gemarkeerde gedeelte een link" placement="top">
                    <el-button
                            class="menubar__button"
                            :class="{ 'is-active': isActive.link() }"
                            @click="addLink"
                    >
                        Link</el-button>
                </el-tooltip>
            </div>
        </editor-menu-bar>

        <editor-content class="editor__content border rounded" :editor="editor" />
    </div>
</template>

<script>
    // Import the editor
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap'
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History
    } from 'tiptap-extensions'
    export default {
        name: "TextEditor",
        components: {
            EditorContent,
            EditorMenuBar,
        },
        props: {
            // Content
            value: String,

            // Number with a default value
            editable: {
                type: Boolean,
                default: true
            },

            current: {
                type: String,
            }
        },
        watch: {
            current: {
                handler (val, oldVal) {
                    this.setContent(val)
                }
            }
        },
        data() {
            return {
                editor: null,
                default: '{"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":"Vul "},{"type":"text","marks":[{"type":"italic"}],"text":"hier"},{"type":"text","text":" een "},{"type":"text","marks":[{"type":"bold"}],"text":"opgemaakte"},{"type":"text","text":" beschrijving in."}]}]}'
            }
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({levels: [1, 2, 3]}),
                    new HorizontalRule(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link({
                        openOnClick: true, // Makes links clickable
                        HTMLAttributes: {
                            target: '_blank', // Opens links in a new tab
                            class: 'editor-link',
                        },
                    }),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new History(),
                ],
                content: this.getCurrent,
                onUpdate: this.updateValue,
                editable: this.editable
            })
            this.editor.setContent(JSON.parse(this.getCurrent))
        },
        beforeDestroy() {
            this.editor.destroy()
        },
        methods: {
            getContent() {
                return this.editor.getHTML();
            },
            setContent(JSONString) {
                if(!JSONString) {
                    this.editor.setContent(JSON.parse(this.default));
                } else {
                    this.editor.setContent(JSON.parse(JSONString));
                }
            },
            updateValue(value) {
                this.$emit('input', JSON.stringify(value.getJSON()));
            },
            addLink() {
                const url = prompt("Plak de volledige link, _inclusief_ het 'https://www.' gedeelte:");
                console.log(url);

                if (url) {
                    this.editor.commands.link({
                        href: url,
                    });
                }
            },
        },
        computed: {
            getCurrent() {
                if(!this.current) {
                    return this.default
                }

                return this.current
            }
        }
    }
</script>

<style>
    .editor__content {
        padding: 5px 15px;
        padding-bottom: 15px;
        box-sizing: border-box !important;
    }
    .editor__content ul, .editor__content ol {
        padding-left: 30px;
    }
    .editor__content ul li {
        list-style-type: circle;
    }
    .editor__content ol li {
        list-style-type: decimal;
    }
    .editor__content li p {
        margin-top: 0px;
    }

    .editor__content {
        line-height: 20px;
    }

    .editor__content p {
        margin-top: 10px;
    }

    .editor__content a {
        text-decoration: underline !important;
        color: #409EFF !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/forms/TextEditor.vue